<template>
  <header class="subnav subnav-filters">
    <div class="container d-flex align-items-center justify-content-between">
      <div class="navbar-group">
        <ul class="nav nav-pills" id="pills-tab" role="tablist" data-v-step="1">
          <li class="nav-item" role="presentation">
            <button
              class="btn btn-sm nav-link caps"
              id="pills-schedule-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-schedule"
              type="button"
              role="tab"
              aria-controls="pills-schedule"
              aria-selected="false"
              :class="[{ active: confStore.tab === 'schedule' }]"
              @click="confStore.tab = 'schedule'"
            >
              Full Schedule
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="btn btn-sm nav-link caps"
              id="pills-agenda-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-agenda"
              type="button"
              role="tab"
              aria-controls="pills-agenda"
              aria-selected="true"
              :class="[{ active: confStore.tab === 'agenda' }]"
              @click="confStore.tab = 'agenda'"
            >
              My Agenda
            </button>
          </li>
        </ul>
      </div>
      <div class="navbar-group actions">
        <button class="print-btn" type="button" @click="print" data-v-step="0">
          <i class="bi-printer" v-if="!state.loadingPrint"></i>
          <v-progress-circular size="small" indeterminate v-else></v-progress-circular>
          <span>Print</span>
        </button>
        <button class="email-btn" type="button" @click="email">
          <i class="bi-envelope" v-if="!state.loadingEmail"></i>
          <v-progress-circular size="small" indeterminate v-else></v-progress-circular>
          <span>Email</span>
        </button>
        <button class="export-btn" type="button" @click="exportCalendar">
          <i class="bi-file-earmark-spreadsheet" v-if="!state.loadingExport"></i>
          <v-progress-circular size="small" indeterminate v-else></v-progress-circular>
          <span>Export</span>
        </button>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { FetchService } from "@/services/fetch.service";
import { useAlertsStore } from "@/stores/alerts";

import { useConferenceStore } from "@/stores/teacher/conference";
import { printSchedule } from "./print/printSchedule";
import { reactive } from "vue";

const confStore = useConferenceStore();
const alertStore = useAlertsStore();

const state = reactive({
  loadingPrint: false,
  loadingEmail: false,
  loadingExport: false
});

async function print() {
  if (state.loadingPrint) return;
  state.loadingPrint = true;
  await printSchedule();
  state.loadingPrint = false;
}
async function email() {
  state.loadingEmail = true;
  let url = "/schedule/email";
  if (confStore.selected?.conference_id) {
    url += "?conference_id=" + confStore.selected?.conference_id;
  }
  try {
    const resp = await FetchService.fetchData(url, "get");
    if (resp?.status === true) {
      alertStore.addAlert("success", "Email has been sent with your schedule");
    } else {
      alertStore.addAlert("error", "Failed to send email to recipient");
    }
  } catch (error) {
    alertStore.addAlert("error", "Failed to send email to recipient");
  } finally {
    state.loadingEmail = false;
  }
}

async function exportCalendar() {
  // let resp = await agendaStore.exportCalendar();
  state.loadingExport = true;
  const resp = await FetchService.fetchData("/schedule/export", "get");
  if (resp?.status) {
    alertStore.addAlert("success", "Schedule is exported to calendar");
  } else alertStore.addAlert("error", resp?.last_response || "Failed to export to calendar");
  downloadString(resp.ics, "application/ics", "invite.ics");
  state.loadingExport = false;
}
function downloadString(text, fileType, fileName) {
  var blob = new Blob([text], { type: fileType });

  var a = document.createElement("a");
  a.download = fileName;
  a.href = URL.createObjectURL(blob);
  a.dataset.downloadurl = [fileType, a.download, a.href].join(":");
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(function () {
    URL.revokeObjectURL(a.href);
  }, 1500);
}
</script>
